const router = [
  {
    path: "/login",
    meta: {
      title: "login",
    },
    component: (resolve) => require(["../views/login/login"], resolve),
  },
  {
    path: "/screen",
    meta: {
      title: "展示大屏",
    },
    component: (resolve) => require(["../views/screen/index"], resolve),
  },
  {
    path: "/dataCenter/china",
    meta: {
      title: "数据中心",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/dataCenter/china"], resolve),
  },
  {
    path: "/dataCenter/world",
    meta: {
      title: "数据中心",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/dataCenter/world"], resolve),
  },
  {
    path: "/dataCenter/shenzhen",
    meta: {
      title: "深圳价格",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/dataCenter/shenzhen"], resolve),
  },
  {
    path: "/error",
    meta: {
      title: "报错",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/error/error"], resolve),
  },
  {
    path: "/register",
    meta: {
      title: "注册",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/register/register"], resolve),
  },
  {
    path: "/forget",
    meta: {
      title: "注册",
      // keepAlive: true
    },
    component: (resolve) => require(["../views/forget/forget"], resolve),
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/router/login.js